import axios from 'axios';
import {convertDateToJSON} from './dateTimeUtils';
import {PicTypes, ScannerAPIURLs} from './enumUtils';
import {VIBO_SERVER_URL} from './generalUtils';

const queryString = require('query-string');

const apiService = axios.create({
    baseURL: VIBO_SERVER_URL,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
});

const prodScannerAPI = axios.create({
    baseURL: ScannerAPIURLs.production,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
});

const stageScannerAPI = axios.create({
    baseURL: ScannerAPIURLs.staging,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
});


class Service {

    login(email, password) {
        return apiService.post('/emailLogin',
            queryString.stringify({
                myUser: JSON.stringify({email: email, pass: password}),
                myGlobalPushNotificationsUserId: "", isGuest: false,
                userId: "", isWebApp: true, isSignIn: true
            })
        )
    }

    restoreSession(userId) {
        return apiService.post('/restoreSession',
            queryString.stringify({
                objectId: userId
            })
        )
    }

    resetPassword(email) {
        return apiService.post('/forgotPassword',
            queryString.stringify({
                email: email
            })
        )
    }

    getEvents(userId) {
        return apiService.get('/events', {
            params: {
                userId: userId,
            }
        })
    }

    addEvent(newEvent, userData) {
        return apiService.post('/events',
            queryString.stringify({
                userId:         userData.id,
                title:          newEvent.title,
                eventType:      newEvent.eventType,
                location:       newEvent.location,
                dateInMillis:   newEvent.date.getTime(),
                dateUfcOffset:  newEvent.date.getTimezoneOffset(),
                dateViboFormat: JSON.stringify(convertDateToJSON(newEvent.date)),
                templateId:     newEvent.templateId
            })
        )
    }

    editEvent(updatedEvent) {
        return apiService.post('/events/' + updatedEvent.objectId,
            queryString.stringify({
                ownerId:                    updatedEvent.ownerId,
                title:                      updatedEvent.title,
                eventType:                  updatedEvent.eventType,
                location:                   updatedEvent.location,
                canHostInviteGuests:        updatedEvent.canHostInviteGuests,
                sectionSongLimit_statement: updatedEvent.sectionSongLimit_statement,
                sectionSongLimit_number:    updatedEvent.sectionSongLimit_number,
                daysToLockEvent:            updatedEvent.daysToLockEvent,
                dateInMillis:               updatedEvent.date.getTime(),
                dateUfcOffset:              updatedEvent.date.getTimezoneOffset(),
                dateViboFormat:             JSON.stringify(convertDateToJSON(updatedEvent.date)),
                arrivalTime:                updatedEvent.arrivalDate ? JSON.stringify(convertDateToJSON(updatedEvent.arrivalDate)) : null,
                endTime:                    updatedEvent.endDate ? JSON.stringify(convertDateToJSON(updatedEvent.endDate)) : null,
            })
        )
    }

    deleteSong(deletedSongId) {
        return apiService.get('/deleteSong', {
            params: {
                songId: deletedSongId,
                isDJ: true,
            }
        })
    }

    getCategoryRecommendationSongs(userId, category) {
        return apiService.get('/getCategoryRecommendations', {
            params: {
                userId: userId,
                category: category
            }
        })
    }

    getEvent(eventId) {
        return apiService.get('/events/' + eventId);
    }

    addSong(videoObject, playlistId, lastPosition, userData) {
        var newDate = new Date();
        return apiService.post('/sendSongRequest',
            queryString.stringify({
                song:                           JSON.stringify(videoObject),
                listType:                       "editRecommendations",
                personalLists_genre:            playlistId,
                isHost:                         false,
                songListType_isParty:           false,
                isCameFromPersonalLists:        true,
                isCameFromSongList:             false,
                isCameFromEditRecommendations:  true,
                isCameFromPersonalArea:         false,
                dateViboFormat:                 JSON.stringify(convertDateToJSON(newDate)),
                currentUser:                    JSON.stringify(userData),
                now_ms:                         newDate.getTime(),
                isIgnore:                       false,
                position:                       (lastPosition + 1)
            })
        )
    }

    addSongFromLink(videoId, userData) {
        return apiService.post('/searchYouTubeLink',
            queryString.stringify({
                song: videoId,
            })
        )
    }

    importSpotifyPlaylistToRecommendationsList(spotifyPlaylistId, spotifyAccessToken, playlistId, lastPosition, numSongsInRecommendationsList, userData) {
        return apiService.post('/recommendations/spotify/import',
            queryString.stringify({
                spotifyPlaylistId,
                spotifyAccessToken,
                playlistId,
                lastPosition,
                numSongsInRecommendationsList,
                userData: JSON.stringify(userData),
            })
        );
    }

    addEventSong(videoObject, listName, userData, eventId) {
        return apiService.post('/sendSongRequest',
            queryString.stringify({
                song:               JSON.stringify(videoObject),
                listType:           listName,
                eventId:            eventId,
                isCameFromSongList: true,
                dateViboFormat:     JSON.stringify(convertDateToJSON(new Date())),
                currentUser:        JSON.stringify(userData),
                now_ms:             new Date().getTime(),
                isIgnore:           false,
            })
        )
    }

    editEventSpecialSong(song, sectionId, eventId) {
        return apiService.post('/events/' + eventId + '/songs/editSpecialSong',
            queryString.stringify({
                songId: song.objectId,
                sectionId: sectionId,
            })
        )
    }

    editEventNote(eventId, note) {
        return apiService.post('/events/' + eventId + '/note',
            queryString.stringify({
                note: note
            })
        )
    }

    editSectionNote(eventId, categoryId, note) {
        return apiService.post('/events/'+ eventId +'/sections/' + categoryId + '/note',
            queryString.stringify({
                note: note
            })
        )
    }

    addTemplate (userId, templateName, defaultTemplateId) {
        return apiService.post('/templates',
            queryString.stringify({
                userId: userId,
                name: templateName,
                defaultTemplateId: defaultTemplateId
            })
        )
    }

    getTemplates(userId) {
        return apiService.get('/templates', {
            params: {
                userId: userId,
            }
        })
    }
    getTemplate(userId, templateId) {
        return apiService.get('/templates/' + templateId, {
            params: {
                userId: userId,
            }
        })
    }

    editTemplate(userId, templateId, updatedTemplate) {
        return apiService.post('/templates/' + templateId,
            queryString.stringify({
                userId: userId,
                template: JSON.stringify(updatedTemplate)
            })
        )
    }

    deleteTemplate(userId, templateId) {
        return apiService.post('/templates/' + templateId + '/delete',
            queryString.stringify({
                userId: userId
            })
        )
    }

    editTemplatePic(userId, templateId, picUrl) {
        return apiService.post('/templates/' + templateId + '/pic',
            queryString.stringify({
                userId: userId,
                picUrl: picUrl
            })
        )
    }

    editEventCoverPic(userId, eventId, picUrl) {
        return apiService.post('/events/' + eventId + '/pic',
            queryString.stringify({
                userId: userId,
                picUrl: picUrl
            })
        )
    }

    getEventSongs(eventId) {
        return apiService.get('/events/' + eventId + '/songs');
    }

    editUserInfo(data, userId) {
        return apiService.post('/users/' + userId,
            queryString.stringify({
                data: JSON.stringify(data)
            })
        )
    }

    uploadPicToGallery(userId, picType, picUrls) {
        var width, height, aspectRatio;

        switch(picType){
            case PicTypes.COVER:
            case PicTypes.TEMPLATE:
            case PicTypes.EVENT_COVER:
                width = 800;
                height = 450;
                aspectRatio = "16:9";
                break;
            default:
                width = 800;
                height = 800;
                aspectRatio = "1:1";
                break;
        }

        return apiService.post('/users/' + userId + '/pictures',
            queryString.stringify({
                picData: picUrls,
                width: width,
                height: height,
                aspectRatio: aspectRatio
            })
        )
    }

    addCategory(category, supportedRegions, userId) {
        return apiService.post('/users/' + userId + '/recCategories',
            queryString.stringify({
                categoryTitle: category,
                supportedRegions: JSON.stringify(supportedRegions)
            })
        )
    }

    editCategory(categoryId, categoryTitle, supportedRegions, userId) {
        return apiService.post('/users/' + userId + '/recCategories/' + categoryId,
            queryString.stringify({
                title: categoryTitle,
                supportedRegions: JSON.stringify(supportedRegions)
            })
        )
    }

    cloneCategory(categoryId, categoryTitle, userId) {
        return apiService.post('/users/' + userId + '/recCategories/' + categoryId + '/clone',
            queryString.stringify({
                title: categoryTitle,
            })
        );
    }

    deleteCategory(categoryId, userId) {
        return apiService.delete('/users/' + userId + '/recCategories/' + categoryId);
    }

    setNewSongPosition(oldPosition, newPosition, categoryId, userId) {
        return apiService.post('/users/' + userId + '/recCategories/' + categoryId + '/position',
            queryString.stringify({
                oldPosition: oldPosition,
                newPosition: newPosition
            })
        )
    }

    getPdfFile(eventId, showDjNotes) {
        return apiService.get('/events/' + eventId + '/pdf', {
            params: {
                showDjNotes: showDjNotes
            }});
    }

    getPlanningFormPdfFile(eventId) {
        return apiService.get('/events/' + eventId + '/downloadPlanningFormAsPDF');
    }

    markEventSongs(songIds, markAsType, eventId) {
        return apiService.post('/events/' + eventId + '/songs/markAs',
            queryString.stringify({
                songIds: JSON.stringify(songIds),
                markAs: markAsType
            })
        )
    }

    deleteEventSongs(songIds, eventId) {
        return apiService.post('/events/' + eventId + '/songs/delete',
            queryString.stringify({
                songIds: JSON.stringify(songIds)
            })
        )
    }

    flagEventSongs(songIds, toFlag, eventId) {
        return apiService.post('/events/' + eventId + '/songs/flag',
            queryString.stringify({
                songIds: JSON.stringify(songIds),
                toFlag: toFlag
            })
        )
    }

    moveEventSongs(songIds, listType, eventId) {
        return apiService.post('/events/' + eventId + '/songs/move',
            queryString.stringify({
                songIds: JSON.stringify(songIds),
                listType: listType,
            })
        )
    }

    deleteEvent(eventId) {
        return apiService.get('/sendDeleteEvent', {
            params: {
                eventId: eventId
            }
        });
    }

    getMatchesForPlaylist(userId, eventId, listType, scannerVersion, isTest) {
        let params_object = {
            params: {
                userId: userId,
                eventId: eventId,
                listType: listType,
                scannerVersion: scannerVersion
            }
        };
        // dispatch api call based on scanner version
        if (isTest){ // goes to scanner stage server
            return stageScannerAPI.get('/find_matches', params_object);
        }
        else{
            return prodScannerAPI.get('/find_matches', params_object);
        }
    }

    getMatchesForSong(userId, eventId, songId, scannerVersion, isTest) {
        let params_object = {
            params: {
                userId: userId,
                eventId: eventId,
                songId: songId,
                scannerVersion: scannerVersion
            }
        };
        if (isTest){ // goes to scanner stage server
            return stageScannerAPI.get('/find_matches_for_single_song', params_object);
        }
        else{
            return prodScannerAPI.get('/find_matches_for_single_song', params_object);
        }
    }

    getMatchesForMultipleSections(userId, eventId, sectionIDs, isTest) {
        return apiService.get('/api/v1/scanner/matchesForMultipleSections', {
            params: {
                isTest,
                userId,
                eventId,
                sectionIDs: JSON.stringify(sectionIDs)
            }
        });
    }

    matchesSelected = (eventId, userId, songs, isTest) => {
        return apiService.post('/api/v1/scanner/matchesSelected',
            queryString.stringify({
                isTest,
                eventId,
                userId,
                songs: JSON.stringify(songs)
            })
        );
    };

    branchHostPermission(eventId) {
        return apiService.post('writeHostPermissionToParseLink',
            queryString.stringify({
                eventId: eventId,
                isHost: true
            })
        )
    }

    setEventHostDeepLink(eventId, link) {
        return apiService.post('/events/' + eventId + '/hostDeepLink',
            queryString.stringify({
                link: link
            })
        )
    }

    getDefaultRecommendationCategories(region) {
        return apiService.get('/recommendations/categories/default', {
            params: {
                region: region
            }
        });
    }

    getDefaultTemplates(region) {
        return apiService.get('/templates/default', {
            params: {
                region: region
            }
        });
    }

    getTemplateActivityTypes(region) {
        return apiService.get('/templates/activityTypes', {
            params: {
                region: region
            }
        });
    }

    getGooglePlacesAutocomplete(searchStr) {
        return apiService.get('/googlePlacesAutocomplete', {
            params: {
                searchStr: searchStr
            }
        });
    }

    registerNewUser(name, email, password, countryName) {
        return apiService.put('/users',
            queryString.stringify({
                name: name,
                email: email,
                password: password,
                countryName: countryName
            })
        )
    }


    deleteActivity(eventId, activityId) {
        return apiService.delete('/events/' + eventId + '/activities/' + activityId);
    }

  getSpotifySuggestions(eventId, activityId, spotifyAccessToken) {
    return apiService.get('/events/' + eventId + '/activities/' + activityId + '/spotify/suggestions',
      {
        params: {
          spotifyAccessToken
        }
      });
  }

    exportSectionToSpotify(eventId, activityIds, spotifyPlaylistName, spotifyAccessToken) {
        return apiService.post('/events/' + eventId + '/activities/spotify/export',
            queryString.stringify({
                sections: activityIds,
                spotifyPlaylistName,
                spotifyAccessToken,
            })
        );
    }

    editActivityTitle(eventId, activityId, title) {
        return apiService.put('/events/' + eventId + '/activities/' + activityId + '/title',
            queryString.stringify({
                title: title
            })
        );
    }

    editActivityTime(eventId, activityId, time) {
        return apiService.put('/events/' + eventId + '/activities/' + activityId + '/time',
            queryString.stringify({
                hour: time.getHours(),
                min: time.getMinutes()
            })
        );
    }

    removeActivityTime(eventId, activityId) {
        return apiService.delete('/events/' + eventId + '/activities/' + activityId + '/time');
    }

    reorderEventSections(sectionIds, eventId) {
        return apiService.post('/events/' + eventId + '/activities/positions/reorder',
            queryString.stringify({
                idsByPosition: sectionIds
            })
        )
    }

    updateEventSectionRecommendations(eventId, activityId, recommendationList){
        return apiService.put(`/events/${eventId}/activities/${activityId}/recommendations`,
            queryString.stringify({
                newList: JSON.stringify(recommendationList)
            })
        )
    }

    addNewContact(newContact, eventId) {
        return apiService.post(`/events/${eventId}/contacts`,
            queryString.stringify({
                contact: JSON.stringify(newContact)
            })
        )
    }

    updateContact(updatedContact, eventId) {
        return apiService.put(`/events/${eventId}/contacts/${updatedContact.id}`,
            queryString.stringify({
                contact: JSON.stringify(updatedContact)
            })
        )
    }

    deleteContact(contactId, eventId) {
        return apiService.delete(`/events/${eventId}/contacts/${contactId}`);
    }

    newSection(newSection, eventId) {
        return apiService.post('/events/' + eventId + '/activities/fullResponse',
            queryString.stringify({
                activity: JSON.stringify(newSection)
            })
        )
    }

    getPlanningForm(eventId) {
        return apiService.get('/events/' + eventId + '/planningForm');
    }

    setPlanningFormInputs(planningFormId, inputs) {
        return apiService.post('/planningForm/' + planningFormId + '/inputs',
            queryString.stringify({
                inputs: JSON.stringify(inputs),
            })
        );
    }

    sendEventLinkEmailToHost(eventId, contactId) {
        return apiService.get('/hostsLinkEmail', {
            params: {
                eventId,
                contactId,
            }
        })
    }

    placePaymentToVibo(userId, paymentData){
        return apiService.post(`/users/${userId}/payments/`,
            queryString.stringify({
                paymentData: JSON.stringify(paymentData),
            })
        );
    }

    checkCoupon(userId, couponId){
        return apiService.post(
            `/users/${userId}/attachCoupon/${couponId}/`,
            queryString.stringify({})
        );
    }

    setScannerTestMode(userId, testMode){
        return apiService.post(
            `/users/${userId}/scannerTestMode/`,
            queryString.stringify({
                testMode
            })
        );
    }

    searchYoutubeVideos(searchStr){
        return apiService.get('/youtubeFinal', {
            params: {
                searchStr
            }
        });
    }

    sendZapierEventDetailsTrigger(eventId, contactId){
        return apiService.get('/zapier/trigger/eventDetails/clientTrigger', {
            params: {
                eventId,
                contactId
            }
        });
    }
}

let service = new Service();
export default service;



// WEBPACK FOOTER //
// ./src/utils/Service.js